import Link from './_link';
import Button from './_button';

const Index = ({href, ...props}) => {
	return (href ? <Link {...props} href={href}/> : <Button {...props}/>)
}

export default Index